module.exports = __webpack_public_path__ + "static/media/Q_7.48149d9e.jpg";